import React from 'react'
import { UseFormReturn } from 'react-hook-form'
import { TableColumnDefs } from 'src/app/shared/components/common/new-table/table.model'

export interface FormValues {
  clientId: string | null
  accountId: string | null
  checkNumber: string
  amount: string
  issuedDate: string
  issuedPayee: string
  autoIncrement: boolean
  voidCheck: boolean
}

export interface ICheck {
  accountName: string
  checkNumber: string
  amount: string
  issuedDate: string
  issuedPayee: string
}

export interface AddNewIssuedCheckContextProps {
  form: UseFormReturn<FormValues>
  clients: Array<{
    id: string
    clientName: string
  }>
  accounts: Array<{
    accountName: string
    accountId: string
  }>
  checkList: Array<ICheck>
  loading: boolean
  loadingClients: boolean
  disabled: boolean
  columnDefs: TableColumnDefs[]
  onSubmit: (values: FormValues) => Promise<any>
}

export const AddNewIssuedCheckContext = React.createContext<AddNewIssuedCheckContextProps>({
  form: null as any,
  clients: [],
  accounts: [],
  checkList: [],
  loading: false,
  loadingClients: false,
  disabled: false,
  columnDefs: [],
  onSubmit: () => Promise.resolve(),
})

export const useAddNewIssuedCheckContext = () => React.useContext(AddNewIssuedCheckContext)
